module.exports = __webpack_public_path__ + "img/orange-and-yellow-lily.7d3dce0b.webp";